// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nHcjz","right":"Footer_right__3vyEP","buttons":"Footer_buttons__1e_Xl"};